import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
const _Trending = (props: React.SVGProps<SVGSVGElement>) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_Trending" data-sentry-source-file="Trending.tsx">
    <path d="M2.03091 13.9501H14.0022M2.01758 9.44146L6.33691 5.12213C6.60091 4.85813 7.03024 4.86213 7.28891 5.13146L8.56825 6.46146C8.82758 6.7308 9.25558 6.7348 9.52024 6.4708L13.1929 2.79813M11.3329 2.0228H13.4189C13.7389 2.0228 14.0009 2.2848 14.0009 2.6048V4.68813" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Trending.tsx" />
  </svg>;
const Trending = memo(_Trending);
export const TrendingWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="TrendingWithIconTag" data-sentry-source-file="Trending.tsx">
    <Trending className={className} data-sentry-element="Trending" data-sentry-source-file="Trending.tsx" />
  </i>;
export default Trending;